var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card card-chat-booking float-left ml-3" }, [
    _c("div", { staticClass: "card-body" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("section", [
        _c("div", [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.radioAddress,
                  expression: "radioAddress"
                }
              ],
              attrs: {
                type: "radio",
                name: "radioAddress",
                value: "user-place-address"
              },
              domProps: {
                checked: _vm._q(_vm.radioAddress, "user-place-address")
              },
              on: {
                change: function($event) {
                  _vm.radioAddress = "user-place-address"
                }
              }
            }),
            _vm._v("\n          ใช้ที่อยู่ที่เลือก\n        ")
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.radioAddress,
                  expression: "radioAddress"
                }
              ],
              attrs: {
                type: "radio",
                name: "radioAddress",
                value: "new-address"
              },
              domProps: { checked: _vm._q(_vm.radioAddress, "new-address") },
              on: {
                change: function($event) {
                  _vm.radioAddress = "new-address"
                }
              }
            }),
            _vm._v(" ใช้ที่อยู่ใหม่\n        ")
          ])
        ]),
        _vm._v(" "),
        _vm.userPlace && _vm.radioAddress === "user-place-address"
          ? _c(
              "div",
              { staticClass: "border shadow-sm rounded mt-2 p-2 text-small" },
              [
                _c("div", [
                  _c("label", [_vm._v(_vm._s(_vm.userPlace.place_name))])
                ]),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.userPlace.place_size.name_th))]),
                _vm._v(" "),
                _c("div", [
                  _c("span", [
                    _vm._v("ที่อยู่: " + _vm._s(_vm.userPlace.address))
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "อำเภอ/เขต: " + _vm._s(_vm.userPlace.district.name_th)
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "จังหวัด: " +
                        _vm._s(_vm.userPlace.address_province.name_th)
                    )
                  ])
                ])
              ]
            )
          : _vm.radioAddress === "new-address"
          ? _c("div", { staticClass: "mt-2" }, [
              _c("section", [
                _c("label", { attrs: { for: "address" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.booking.contact_step.address")) +
                      " - " +
                      _vm._s(
                        _vm.$t("message.booking.contact_step.address_remark")
                      )
                  )
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.submitData.building_address,
                      expression: "submitData.building_address"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "address",
                  staticClass: "form-control input-jumbo",
                  class: { "form-alert": _vm.errors.has("address") },
                  attrs: { type: "text", id: "address", name: "address" },
                  domProps: { value: _vm.submitData.building_address },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.submitData,
                        "building_address",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _vm.errors.has("address")
                  ? _c(
                      "div",
                      { staticClass: "mt-1 text-remark -status-alert" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.required_field")) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "pt-3" }, [
                _c("label", { attrs: { for: "addressProvince" } }, [
                  _vm._v(_vm._s(_vm.$t("message.business.contact_province")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-jumbo" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.submitData.address_province_id,
                          expression: "submitData.address_province_id"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: {
                        "form-alert": _vm.errors.has("addressProvince")
                      },
                      attrs: { id: "addressProvince", name: "addressProvince" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.submitData,
                            "address_province_id",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("message.booking.contact_step.set_province")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.sortedProvinces, function(
                        addressProvince,
                        index
                      ) {
                        return _c(
                          "option",
                          { domProps: { value: addressProvince.id } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("multiLangName")(addressProvince)
                                ) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _vm.errors.has("addressProvince")
                  ? _c(
                      "div",
                      { staticClass: "mt-1 text-remark -status-alert" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.required_field")) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row pt-3 no-gutters" }, [
                _c("div", { staticClass: "col-6 pr-1" }, [
                  _c("label", { attrs: { for: "district" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("message.booking.contact_step.district"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "select-jumbo" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.submitData.district_id,
                            expression: "submitData.district_id"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        class: { "form-alert": _vm.errors.has("district") },
                        attrs: { id: "district", name: "district" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.submitData,
                              "district_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.booking.contact_step.set_district"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.sortedDistricts, function(district, index) {
                          return _c(
                            "option",
                            { domProps: { value: district.id } },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm._f("multiLangName")(district)) +
                                  "\n                "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _vm.errors.has("district")
                    ? _c(
                        "div",
                        { staticClass: "mt-1 text-remark -status-alert" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("message.required_field")) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 pl-1" }, [
                  _c("label", { attrs: { for: "sub-district" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("message.booking.contact_step.sub_district2")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "select-jumbo" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.submitData.sub_district_id,
                            expression: "submitData.sub_district_id"
                          }
                        ],
                        attrs: { id: "sub-district" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.submitData,
                              "sub_district_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "message.booking.contact_step.set_sub_district"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.sortedSubDistricts, function(
                          subDistrcict,
                          index
                        ) {
                          return _c(
                            "option",
                            { domProps: { value: subDistrcict.id } },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("multiLangName")(subDistrcict)
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h4", { staticClass: "pb-2" }, [
            _c("i", { staticClass: "fal fa-images fa-lg" }),
            _vm._v(
              "  " +
                _vm._s(
                  _vm.$t("message.service_request.big_cleaning_attach_photos")
                ) +
                "\n        "
            ),
            _vm.errorNoUploadPhoto
              ? _c("span", { staticClass: "text-danger" }, [
                  _c("i", { staticClass: "fa fa-exclamation-circle" })
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-remark mb-2" }, [
            _c("i", { staticClass: "fas fa-circle fa-sm -status-pending" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.bookingData &&
                    _vm.bookingData.service_request &&
                    _vm.bookingData.service_request.service_id === 49
                    ? _vm.$t(
                        "message.service_request.upholstery_cleaning_attach_photos_remark"
                      )
                    : _vm.$t(
                        "message.service_request.big_cleaning_attach_photos_remark"
                      )
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("vue-dropzone", {
            ref: "vueDropzone",
            staticClass: "dropzone-dashed",
            attrs: { id: "dropzone", options: _vm.dropzoneOptions },
            on: { "vdropzone-file-added": _vm.clearFileUploadError }
          }),
          _vm._v(" "),
          _vm.errorNoUploadPhoto
            ? _c("div", { staticClass: "mt-2 text-remark -status-alert" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.required_photo_attachment")) +
                    "\n      "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pt-4" }, [
        _c("h4", { staticClass: "pb-2" }, [
          _vm._v(_vm._s(_vm.$t("message.service_request.big_cleaning_remark")))
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.submitData.remark,
              expression: "submitData.remark"
            }
          ],
          ref: "remark",
          staticClass: "form-control textarea-jumbo",
          attrs: {
            rows: "3",
            id: "remark",
            placeholder: _vm.$i18n.t(
              "message.service_request.big_cleaning_remark_placeholder"
            )
          },
          domProps: { value: _vm.submitData.remark },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.submitData, "remark", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "text-small" }, [
        _c("h4", { staticClass: "pb-2 text-orange" }, [
          _vm._v(
            _vm._s(
              _vm.$t("message.service_request.service_request_condition_title")
            )
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "list-unstyled" }, [
          _c("li", { staticClass: "pb-3" }, [
            _c("i", { staticClass: "fas fa-circle fa-xs -status-pending" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("message.service_request.service_request_remark01")
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "pb-3" }, [
            _c("i", { staticClass: "fas fa-circle fa-xs -status-pending" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("message.service_request.service_request_remark02")
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _c("i", { staticClass: "fas fa-circle fa-xs -status-pending" }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("message.service_request.service_request_remark03")
                ) +
                "\n        "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.saveSuccess
        ? _c("div", { staticClass: "form-group pt-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-block btn-info",
                attrs: { disabled: _vm.isSubmitting },
                on: {
                  click: function($event) {
                    return _vm.submit()
                  }
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.isSubmitting ? "กำลังส่งคำขอ..." : "ส่งคำขอ") +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-block btn btn-outline-secondary",
                on: {
                  click: function($event) {
                    return _vm.cancelRequest()
                  }
                }
              },
              [_vm._v("ยกเลิก")]
            )
          ])
        : _c("div", { staticClass: "text-center mt-4" }, [_vm._m(1)])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-3" }, [
      _c("b", [_vm._v("ที่อยู่สำหรับรับบริการ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("i", { staticClass: "fas fa-check-circle -status-accepted" }),
      _vm._v(" บันทึกข้อมูลสำเร็จ\n      ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59b08744", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b08744","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/ServiceRequestSecondMessage.vue
// module id = 2243
// module chunks = 0